import styled, { css } from "styled-components";
import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import { A, P } from "@/lib/styles";

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 16px;

  ${({ theme }) => theme.mediaQueries.laptop} {
    gap: 18px;
  }
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding-bottom: 2px;
`;

export const LabelText = styled(P)`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.darkMiddle};
  text-transform: uppercase;
`;

export const Title = styled(P)`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
`;

export const Link = styled(A)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;

  & p {
    color: ${({ theme }) => theme.colors.red};
  }
`;

